export default __webpack_public_path__ + "static/media/illustration.192a98c0.png";